const AjaxForm = function ($form) {
    const ajaxForm = this;

    ajaxForm.$form = $form;
    ajaxForm.queued = {$inputs: $(), promise: null};
    ajaxForm.processing = {$inputs: $(), promise: null};

    ajaxForm.bindInputs($(ajaxForm.$form[0].elements).filter(':input[name]'));
};

AjaxForm.prototype.bindInputs = function ($inputs) {
    const ajaxForm = this;

    // Bind events on inputs
    $inputs.on('change.ajaxForm', function () {
        ajaxForm.handleChangedInputs($(this));
    });

    // For text inputs:
    //  - Abort if a key is pressed while auto-save was pending.
    //  - After 30 seconds of inactivity, consider input as changed, even if it still has focus.
    $inputs.filter(':text, textarea').on({
        'input.ajaxForm': function () {
            const $input = $(this);

            ajaxForm.abortInputs($input);

            clearTimeout($input.data('inactivityTimeout'));
            $input.data('inactivityTimeout', setTimeout(() => ajaxForm.handleChangedInputs($input), 30000));
        },
        'change.ajaxForm': function () {
            const $input = $(this);

            clearTimeout($input.data('inactivityTimeout'));
            $input.removeData('inactivityTimeout');
        },
    });

    // For radio buttons: on change, abort other radio buttons of the same group.
    $inputs.filter(':radio').on('change.ajaxForm', function () {
        ajaxForm.abortInputs(ajaxForm.getInputsByName(this.name).not(this));
    });
};

AjaxForm.prototype.getInputName = function ($input) {
    return $input.prop('name');
};

AjaxForm.prototype.getInputNames = function ($inputs) {
    const ajaxForm = this;

    return [...new Set($inputs.get().map(input => ajaxForm.getInputName($(input))))];
};

AjaxForm.prototype.getRelatedInputNames = function ($inputs) {
    const ajaxForm = this;

    return ajaxForm.getInputNames($inputs);
};

AjaxForm.prototype.getRelatedInputs = function ($inputs) {
    const ajaxForm = this;

    return ajaxForm.getInputsByName(ajaxForm.getRelatedInputNames($inputs));
};

AjaxForm.prototype.getInputsByName = function (names) {
    const ajaxForm = this;

    if (! Array.isArray(names)) {
        names = [names];
    }

    return $(names.flatMap(function (name) {
        const input = ajaxForm.$form[0][name];

        if (input instanceof RadioNodeList) {
            return Array.from(input);
        }

        if (input instanceof HTMLFieldSetElement) {
            return Array.from(input.elements);
        }

        return input;
    })).filter(':input[name]');
};

AjaxForm.prototype.getFields = function ($inputs) {
    return $inputs.not('.form-field-input').add($inputs.filter('.form-field-input').closest('.form-field'));
};

AjaxForm.prototype.handleChangedInputs = function ($inputs) {
    const ajaxForm = this;

    // Queue input
    ajaxForm.queued.$inputs = ajaxForm.queued.$inputs.add($inputs);
    ajaxForm.processing.$inputs = ajaxForm.processing.$inputs.not($inputs);
    ajaxForm.showInputsAsPending($inputs);

    // Handle queue
    return ajaxForm.handleQueue();
};

AjaxForm.prototype.handleQueue = function () {
    const ajaxForm = this;

    if (ajaxForm.queued.promise) {
        return ajaxForm.queued.promise;
    }

    const nextEventCycle = $.Deferred();
    setTimeout(() => nextEventCycle.resolve(), 0);

    return ajaxForm.queued.promise = $.when(ajaxForm.processing.promise, nextEventCycle)
        .then(function () {
            ajaxForm.processing = ajaxForm.queued;
            ajaxForm.queued = {$inputs: $(), promise: null};

            return ajaxForm.sendInputsData(ajaxForm.processing.$inputs);
        })
        .then(function () {
            ajaxForm.showInputsAsDone(ajaxForm.processing.$inputs);
            ajaxForm.processing = {$inputs: $(), promise: null};
        });
};

AjaxForm.prototype.abortInputs = function ($inputs) {
    const ajaxForm = this;

    ajaxForm.queued.$inputs = ajaxForm.queued.$inputs.not($inputs);
    ajaxForm.processing.$inputs = ajaxForm.processing.$inputs.not($inputs);
    ajaxForm.showInputsAsDone($inputs);
};

AjaxForm.prototype.toggleInputClasses = function ($inputs, toggledStates) {
    for (const state in toggledStates) {
        $inputs.toggleClass('is-' + state, toggledStates[state]);
    }

    $inputs.trigger('changeValidationState.sysVision', toggledStates);

    const $containers = $inputs.parents('.form-validation-container')
        .add($inputs.filter('.form-field-input').closest('.form-field'));

    for (const state in toggledStates) {
        let stateContainers = $containers;
        if (! toggledStates[state]) {
            stateContainers = $containers.not(':has(.is-' + state + ')');
        }

        $containers.toggleClass('is-' + state, toggledStates[state]);
    }
};

AjaxForm.prototype.showInputsAsPending = function ($inputs) {
    const ajaxForm = this;

    ajaxForm.toggleInputClasses($inputs, {pending: true});
};

AjaxForm.prototype.showInputsAsDone = function ($inputs) {
    const ajaxForm = this;

    ajaxForm.toggleInputClasses($inputs, {pending: false});
};

AjaxForm.prototype.showInputsAsValid = function ($inputs) {
    const ajaxForm = this;

    if (! $inputs.length) {
        return;
    }

    // Clear error message, if any
    $inputs
        .filter('.form-field-input')
        .closest('.form-field')
        .children('.form-field-content')
        .children('.invalid-feedback')
        .html('');

    // Show inputs as valid for 1 seconds
    ajaxForm.toggleInputClasses($inputs, {valid: true, invalid: false});

    $inputs.each(function () {
        const $input = $(this);

        clearTimeout($input.data('validityTimeout'));
        $input.data('validityTimeout', setTimeout(() => ajaxForm.toggleInputClasses($input, {valid: false}), 1000));
    });
};

AjaxForm.prototype.showInputsAsInvalid = function ($inputs, messages) {
    const ajaxForm = this;

    if (! $inputs.length) {
        return;
    }

    // Set error message
    $inputs
        .filter('.form-field-input')
        .closest('.form-field')
        .children('.form-field-content')
        .children('.invalid-feedback')
        .html('')
        .append(
            (messages ?? [])
                .map(msg => document.createTextNode(msg))
                .flatMap((msg, idx) => idx ? ['<br>', msg] : msg)
        );

    // Show inputs as invalid
    ajaxForm.toggleInputClasses($inputs, {valid: false, invalid: true});

    $inputs.each(function () {
        const $input = $(this);

        clearTimeout($input.data('validityTimeout'));
        $input.removeData('validityTimeout');
    });
};

AjaxForm.prototype.sendInputsData = function ($inputs) {
    const ajaxForm = this;
    const $relatedInputs = ajaxForm.getRelatedInputs($inputs);
    const data = ajaxForm.getInputsData($relatedInputs);

    return ajaxForm.sendData(data).then(
        response => ajaxForm.handleAjaxResponse(response, $inputs),
        xhr => ajaxForm.handleAjaxFailure(xhr, $inputs),
    );
};

AjaxForm.prototype.sendData = function (data) {
    const ajaxForm = this;

    if (! data.length) {
        return $.Deferred().resolve({});
    }

    return $.ajax({
        url: ajaxForm.$form.attr('action'),
        type: ajaxForm.$form.attr('method'),
        data: data,
        dataType: 'json',
    });
};

AjaxForm.prototype.handleAjaxResponse = function (response, $inputs) {
    const ajaxForm = this;

    ajaxForm.showInputsAsValid($inputs);

    return null;
};

AjaxForm.prototype.handleAjaxFailure = function (xhr, $inputs) {
    const ajaxForm = this;
    const message = xhr.responseJSON?.message
        || xhr.responseJSON?.exception
        || (xhr.status + ' ' + xhr.statusText);

    ajaxForm.showInputsAsInvalid($inputs, [message]);

    return null;
};

AjaxForm.prototype.getInputsData = function ($inputs) {
    const data = [];
    const dataLength = {};

    // Add data from inputs
    $inputs.each(function () {
        const $input = $(this);
        let values;

        if (! this.name) {
            return;
        }

        if ($input.is(':checkbox, :radio') && ! $input.is(':checked')) {
            values = [];
        } else {
            const value = $input.val();

            if (value === null) {
                values = [];
            } else if (Array.isArray(value)) {
                values = value;
            } else {
                values = [value];
            }
        }

        for (const value of values) {
            data.push({name: this.name, value: value.replace(/\r?\n/g, '\r\n')});
        }

        const name = this.name.replace(/\[]$/, '');
        dataLength[name] = (dataLength[name] ?? 0) + values.length;
    });

    // Add empty fields to data
    for (const name in dataLength) {
        if (! dataLength[name]) {
            data.push({name: name, value: null});
        }
    }

    return data;
};

AjaxForm.prototype.clearInputs = function ($inputs) {
    $inputs.each(function () {
        const $input = $(this);

        if ($input.is(':radio')) {
            if ($input.val() === '' && ! $input.is(':checked')) {
                $input.prop('checked', true).trigger('change');
            }
        } else if ($input.is(':checkbox')) {
            if ($input.is(':checked')) {
                $input.prop('checked', false).trigger('change');
            }
        } else if ($input.val() !== '') {
            $input.val('').trigger('change');
        }
    });
};

$.fn.ajaxForm = function () {
    this.each(function () {
        const $form = $(this);

        if (! $form.data('ajaxForm')) {
            $form.data('ajaxForm', new AjaxForm($form));
        }
    });

    return this.data('ajaxForm');
};

$(function () {
    $('.ajax-form').ajaxForm();
});

export default AjaxForm;
